import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { setCookie, hasCookie } from "../../utils/cookies";

const DISMISS_COOKIE = "survey_dismissed";
const COMPLETE_COOKIE = "survey_completed";
const DISMISS_EXPIRY_DAYS = 7;
const COMPLETE_EXPIRY_DAYS = 90;

interface SurveyPopupProps {
  /** Survey URL to redirect to */
  surveyUrl?: string;
  /** Title shown in the popup */
  title?: string;
  /** Message shown in the popup */
  message?: string;
}

const SurveyPopup: React.FC<SurveyPopupProps> = ({
  surveyUrl = "https://forms.google.com/your-survey-link",
  title = "What would make Data Revival better for you?",
  message = "Whether you're an individual or an organisation member, your feedback helps us build a better platform for everyone.",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!hasCookie(DISMISS_COOKIE) && !hasCookie(COMPLETE_COOKIE)) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setCookie(DISMISS_COOKIE, "true", DISMISS_EXPIRY_DAYS);
  };

  const handleTakeSurvey = () => {
    window.open(surveyUrl, "_blank");
    setIsVisible(false);
    setCookie(COMPLETE_COOKIE, "true", COMPLETE_EXPIRY_DAYS);
  };

  if (!isVisible) return null;

  return (
    <div className="mx-4 mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4 relative flex-shrink-0">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-blue-400 hover:text-blue-600 transition-colors"
        aria-label="Close survey popup"
      >
        <X size={16} />
      </button>
      <h4 className="text-blue-900 font-semibold text-sm mb-2">{title}</h4>
      <p className="text-blue-700 text-xs mb-3">{message}</p>
      <div className="flex gap-2">
        <button
          onClick={handleTakeSurvey}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-3 py-2 rounded text-xs transition-colors"
        >
          Take survey
        </button>
      </div>
    </div>
  );
};

export default SurveyPopup;
